(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-header-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  var sort = document.querySelector('[data-collection-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  var filterForm = document.querySelector('[data-collection-filters]');
  if (filterForm) {
    filterForm.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches('[data-filter-input]')) return;
      if (target.type === 'number') return;
      filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-code]');
    if (!btn) return;
    var code = btn.getAttribute('data-copy-code');
    if (!code) return;
    var label = btn.querySelector('[data-copy-label]') || btn;
    var previous = label.textContent;
    function done() {
      label.textContent = 'Copied!';
      btn.classList.add('is-copied');
      setTimeout(function () {
        label.textContent = previous;
        btn.classList.remove('is-copied');
      }, 1600);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        label.textContent = code;
      });
    } else {
      done();
    }
  });

  var root = document.querySelector('[data-hero-carousel]');
  if (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length >= 2) {
      var dotsWrap = root.querySelector('[data-hero-dots]');
      var i = 0;
      var timer;

      slides.forEach(function (_, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hero__dot' + (idx === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Slide ' + (idx + 1));
        b.addEventListener('click', function () { go(idx); });
        if (dotsWrap) dotsWrap.appendChild(b);
      });

      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, idx) {
            d.classList.toggle('is-active', idx === i);
          });
        }
        restart();
      }

      function restart() {
        clearInterval(timer);
        if (!reduceMotion) timer = setInterval(function () { go(i + 1); }, 5000);
      }

      var prev = root.querySelector('[data-hero-prev]');
      var next = root.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      restart();
    }
  }

  /* Soft fade/slide-in for marketplace sections */
  var revealNodes = document.querySelectorAll('[data-reveal], .reveal');
  if (revealNodes.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(revealNodes, function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      Array.prototype.forEach.call(revealNodes, function (el) { io.observe(el); });
    }
  }

  /* Quantity steppers */
  document.addEventListener('click', function (event) {
    var changeBtn = event.target.closest('[data-qty-change]');
    if (!changeBtn) return;
    var wrap = changeBtn.closest('[data-qty-stepper]');
    if (!wrap) return;
    var input = wrap.querySelector('.qty-stepper__input, input[type="number"]');
    if (!input) return;
    var delta = parseInt(changeBtn.getAttribute('data-qty-change'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var next = (parseInt(input.value, 10) || min) + delta;
    if (next < min) next = min;
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Add to List (wishlist) on product cards */
  var LIST_KEY = 'tcg_wishlist_ids';
  function readList() {
    try {
      var raw = localStorage.getItem(LIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      return [];
    }
  }
  function writeList(ids) {
    try { localStorage.setItem(LIST_KEY, JSON.stringify(ids)); } catch (e) { /* ignore */ }
  }
  function syncListButtons() {
    var ids = readList();
    Array.prototype.forEach.call(document.querySelectorAll('[data-add-to-list]'), function (btn) {
      var id = String(btn.getAttribute('data-product-id') || '');
      var on = id && ids.indexOf(id) !== -1;
      btn.classList.toggle('is-listed', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? 'Listed' : 'List';
    });
  }
  syncListButtons();
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-add-to-list]');
    if (!btn) return;
    event.preventDefault();
    var id = String(btn.getAttribute('data-product-id') || '');
    if (!id) return;
    var ids = readList();
    var idx = ids.indexOf(id);
    if (idx === -1) ids.push(id);
    else ids.splice(idx, 1);
    writeList(ids);
    syncListButtons();
  });

  /* ATC micro-success + open Added to Cart drawer (demo / live) */
  function moneyDemo(n) {
    return '$' + Number(n).toFixed(2);
  }

  function openDemoAtcDrawer(sourceBtn) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var card = sourceBtn && sourceBtn.closest('.product-card, .product, [data-product-page]');
    var titleEl = card && (card.querySelector('.product__title, .product-card__title, .product-sticky__meta strong'));
    var priceEl = card && (card.querySelector('.product__price, .product-card__price'));
    var imgEl = card && (card.querySelector('.product__image, .product-card__media img'));
    var sellerEl = card && card.querySelector('.seller-meta__name');
    var setEl = card && (card.querySelector('.product__subtitle, .product-card__title'));
    var condEl = document.getElementById('demo-condition');

    var title = (titleEl && titleEl.textContent.trim()) || 'Rayquaza ★ 107/107 — Deoxys Holofoil';
    var priceText = (priceEl && priceEl.childNodes[0] && priceEl.childNodes[0].textContent.trim()) ||
      (priceEl && priceEl.textContent.replace(/\s+/g, ' ').trim().split(' ')[0]) || '$48.99';
    var priceNum = parseFloat(String(priceText).replace(/[^0-9.]/g, '')) || 48.99;
    var img = (imgEl && (imgEl.currentSrc || imgEl.src)) || 'assets/product-1.png';
    var seller = (sellerEl && sellerEl.textContent.trim()) || 'CardKingdom';
    var setName = 'Deoxys';
    if (setEl && setEl.classList.contains('product__subtitle')) {
      var sub = setEl.textContent.trim();
      if (sub) setName = sub.split('·')[0].trim() || setName;
    }
    var condition = (condEl && condEl.value) || 'Near Mint Holofoil';

    var body = drawer.querySelector('[data-cart-drawer-body]');
    var heading = drawer.querySelector('[data-atc-drawer-title]');
    if (heading) heading.textContent = 'Added to Cart';
    if (body) {
      body.innerHTML =
        '<div class="atc-drawer__added">' +
          '<div class="atc-drawer__item">' +
            '<img src="' + img + '" width="72" height="72" alt="">' +
            '<div class="atc-drawer__item-main">' +
              '<strong class="atc-drawer__title">' + title + '</strong>' +
              '<a class="atc-drawer__set" href="#produit">&gt; ' + setName + '</a>' +
              '<div class="atc-drawer__condition">' + condition + '</div>' +
            '</div>' +
            '<div class="atc-drawer__qty-price">1 x <strong>' + moneyDemo(priceNum) + '</strong></div>' +
          '</div>' +
          '<a class="atc-drawer__seller" href="#">Shop for more items from ' + seller + '</a>' +
        '</div>' +
        '<div class="atc-drawer__summary">' +
          '<div class="atc-drawer__summary-row">' +
            '<strong>Cart Summary</strong>' +
            '<strong data-cart-drawer-subtotal>' + moneyDemo(priceNum) + '</strong>' +
          '</div>' +
          '<div class="atc-drawer__summary-row atc-drawer__summary-row--items">' +
            '<span>Items</span><strong>1</strong>' +
          '</div>' +
        '</div>' +
        '<div class="atc-drawer__actions">' +
          '<div class="atc-drawer__actions-row">' +
            '<a class="btn btn--secondary atc-drawer__btn" href="#">Check Out</a>' +
            '<a class="btn btn--secondary atc-drawer__btn" href="#">View Cart</a>' +
          '</div>' +
          '<button type="button" class="btn btn--tcg-blue btn--full atc-drawer__continue" data-cart-drawer-close>Continue Shopping</button>' +
        '</div>' +
        '<div class="atc-drawer__also">' +
          '<h3 class="atc-drawer__also-title">Customers Also Purchased</h3>' +
          '<div class="atc-drawer__also-list" data-atc-also>' +
            '<a class="atc-drawer__also-item" href="#produit">' +
              '<img src="assets/product-2.png" width="44" height="44" alt="">' +
              '<span class="atc-drawer__also-copy"><strong>Deoxys ex 155/162</strong><span class="atc-drawer__also-set">Temporal Forces</span></span>' +
            '</a>' +
            '<a class="atc-drawer__also-item" href="#produit">' +
              '<img src="assets/product-3.png" width="44" height="44" alt="">' +
              '<span class="atc-drawer__also-copy"><strong>Magician of Dark Chaos</strong><span class="atc-drawer__also-set">Chaos Origins</span></span>' +
            '</a>' +
            '<a class="atc-drawer__also-item" href="#produit">' +
              '<img src="assets/product-1.png" width="44" height="44" alt="">' +
              '<span class="atc-drawer__also-copy"><strong>Charizard VMAX</strong><span class="atc-drawer__also-set">Champions Path</span></span>' +
            '</a>' +
          '</div>' +
        '</div>';
    }

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('atc-drawer-open');

    var countEls = document.querySelectorAll('[data-cart-count], .header-cart__count');
    countEls.forEach(function (el) {
      el.textContent = '1';
      el.hidden = false;
    });
  }

  function closeDemoAtcDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('atc-drawer-open');
  }

  function flashAtc(btn) {
    if (!btn || btn.disabled) return;
    var previous = btn.textContent;
    btn.classList.add('is-success');
    if (btn.hasAttribute('data-demo-atc')) {
      btn.textContent = 'Added ✓';
      openDemoAtcDrawer(btn);
      setTimeout(function () {
        btn.textContent = previous;
        btn.classList.remove('is-success');
      }, 1200);
    } else {
      setTimeout(function () { btn.classList.remove('is-success'); }, 700);
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDemoAtcDrawer();
      return;
    }
    var demo = event.target.closest('[data-demo-atc]');
    if (!demo) return;
    event.preventDefault();
    flashAtc(demo);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDemoAtcDrawer();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-type="add-to-cart-form"]');
    if (!form) return;
    var atc = form.querySelector('[data-add-to-cart-button]');
    if (atc) flashAtc(atc);
  });

  /* Product gallery thumb swap */
  document.querySelectorAll('.product__gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.product__image, .product__gallery > img');
    var thumbs = gallery.querySelectorAll('.product__thumbs img');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (thumb.src) main.src = thumb.src;
      });
    });
  });

  /* Sticky ATC + Buy Now — always pinned to bottom on product pages */
  var sticky = document.querySelector('[data-product-sticky]');
  if (sticky) {
    sticky.hidden = false;
    sticky.classList.add('is-visible');

    var stickyBtn = sticky.querySelector('[data-sticky-atc]');
    var mainAtc = document.querySelector('[data-add-to-cart-button]');
    if (stickyBtn && mainAtc) {
      stickyBtn.addEventListener('click', function () {
        if (mainAtc.hasAttribute('data-demo-atc')) {
          flashAtc(stickyBtn);
        } else {
          mainAtc.click();
          flashAtc(stickyBtn);
        }
      });
    }
  }
})();
